<template>
  <div class="page page__list">
    <div class="nav">
      <span
        :class="selected == '费用汇总表' ? 'selected' : ''"
        @click="toggle('费用汇总表')"
        >费用汇总表</span
      >
      <span>|</span>
      <span
        :class="selected == '业务费用分析' ? 'selected' : ''"
        @click="toggle('业务费用分析')"
        >业务费用分析</span
      >
    </div>

    <Statistics v-if="selected === '费用汇总表'" />

    <Please v-if="selected === '业务费用分析'" />
  </div>
</template>

<script>
import Statistics from "@/components/FinanceReportFeestatistics/Statistics.vue";
import Please from "@/components/FinanceReportFeestatistics/Please.vue";

export default {
  components: {
    Statistics,
    Please,
  },
  data() {
    return {
      selected: "费用汇总表",
    };
  },
  methods: {
    toggle(val) {
      this.selected = val;
    },
  },
};
</script>

<style scoped>
.nav {
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  background: var(--weui-BG);
}
.nav .selected {
  color: #38559f;
}
@media screen and (min-width: 500px) {
  .nav {
    display: none;
  }
}
</style>